// Copyright 2016 Sorama B.V.

import { bindable, customElement } from "aurelia-framework";

@customElement("spinner")
export class Spinner {
    // Public properties
    @bindable visible = true;
    @bindable size = "30px";
}
